/**
 * @generated SignedSource<<50fdd16a59aad67cc2440ad3d3d2ab8a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentCheckoutDeactivated_checkout$data = {
  readonly company: {
    readonly nameFriendly: string | null | undefined;
    readonly projectType: string | null | undefined;
    readonly taxID: {
      readonly taxID: string | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"PaymentCheckoutCompanyData_company" | "PaymentCompanySupport_company">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentCheckoutTitle_checkout">;
  readonly " $fragmentType": "PaymentCheckoutDeactivated_checkout";
};
export type PaymentCheckoutDeactivated_checkout$key = {
  readonly " $data"?: PaymentCheckoutDeactivated_checkout$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentCheckoutDeactivated_checkout">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentCheckoutDeactivated_checkout",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameFriendly",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TaxID",
          "kind": "LinkedField",
          "name": "taxID",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "taxID",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PaymentCheckoutCompanyData_company"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PaymentCompanySupport_company"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentCheckoutTitle_checkout"
    }
  ],
  "type": "Checkout",
  "abstractKey": null
};

(node as any).hash = "22c7fbc523ddfb242261497e3a3aad11";

export default node;
